import store from '@/services/store'
import axios from '@/services/axios'

export const db = {
  initApp,
  fetchProducts,
}

function initApp() {
  try {
    return axios.get('/InitApp')
  } catch (e) {
    return Promise.reject()
  }

}

function fetchProducts() {
  store.commit('changeStatusProductsLoading', false)
  axios
    .request({
      url: '/GoodsList',
    })
    .then(resp => {
      store.commit('fetchProducts', resp.data)
    })
    .catch(err => {
      console.error('fetchProducts.err: ', err)
    })
}
